import { render } from "./CvdGasProperties.vue?vue&type=template&id=07f43a9b"
import script from "./CvdGasProperties.vue?vue&type=script&lang=js"
export * from "./CvdGasProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__